/* Cayo Hueso - shared seamless photo reel (password-page splash AND the homepage intro overlay).
   Two identical copies of the photo strip, whole-pixel image widths, compositor-driven Web Animations
   moving left-to-right; GPU layers split into segments (iOS-friendly). Reduced motion = static frame.
   Usage: var ctl = CayoReel(reelEl, photos[{webp,jpg,w,h}], { speed, maxSegAspect, waitMax, lowPriority, onReady }) */
(function () {
  'use strict';
  function withFallback(img, fallback) {
    if (!fallback) return;
    img.addEventListener('error', function onErr() { img.removeEventListener('error', onErr); img.src = fallback; });
  }
  window.CayoReel = function (reel, photos, o) {
    o = o || {};
    var speed = o.speed || 40, MAX_SEG_ASPECT = o.maxSegAspect || 3.2, WAIT = o.waitMax || 8000;
    var reduceMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    var anims = [], cycleMs = 0, distance = 0, segs = [], copyA = [], copyB = [], allImgs = [], dead = false;
    function makeCopy() {
      var out = [], seg = null, aspect = 0;
      photos.forEach(function (p) {
        var a = p.w / p.h;
        if (!seg || aspect + a > MAX_SEG_ASPECT) { seg = document.createElement('div'); seg.className = 'cayo-reel-seg'; out.push(seg); aspect = 0; }
        aspect += a;
        var img = document.createElement('img');
        img.width = p.w; img.height = p.h; img.alt = ''; img.decoding = 'async'; img.draggable = false;
        if (o.lowPriority) { img.setAttribute('fetchpriority', 'low'); }
        withFallback(img, p.jpg);
        img.src = p.webp;
        seg.appendChild(img); allImgs.push(img);
      });
      return out;
    }
    function sizeImages() {
      var h = reel.getBoundingClientRect().height;
      allImgs.forEach(function (img) { img.style.width = Math.round(h * img.width / img.height) + 'px'; });
    }
    function measure() { sizeImages(); return copyB[0].getBoundingClientRect().left - copyA[0].getBoundingClientRect().left; }
    function stopReel() {
      var progress = 0;
      if (anims.length && cycleMs) progress = ((anims[0].currentTime || 0) % cycleMs) / cycleMs;
      anims.forEach(function (a) { a.cancel(); }); anims = [];
      return progress;
    }
    function startReel(progress) {
      distance = measure();
      if (!(distance > 0)) return;
      if (reduceMQ.matches || !reel.animate) return;          // static frame
      cycleMs = distance / speed * 1000;
      var kf = [{ transform: 'translate3d(' + (-distance) + 'px,0,0)' }, { transform: 'translate3d(0,0,0)' }];
      segs.forEach(function (s) { anims.push(s.animate(kf, { duration: cycleMs, iterations: Infinity, easing: 'linear' })); });
      var t = (progress || 0) * cycleMs;
      anims.forEach(function (a) { a.currentTime = t; });
    }
    var ctl = { distance: function () { return distance; }, cycleMs: function () { return cycleMs; }, anims: function () { return anims; }, destroy: destroy };
    if (!reel || !photos || !photos.length) return ctl;
    copyA = makeCopy(); copyB = makeCopy(); segs = copyA.concat(copyB);
    segs.forEach(function (s) { reel.appendChild(s); });
    var jobs = allImgs.map(function (img) {
      return new Promise(function (resolve) {
        function tryDecode() { (img.decode ? img.decode() : Promise.resolve()).then(resolve, function () { setTimeout(resolve, 50); }); }
        if (img.complete && img.naturalWidth) tryDecode(); else img.addEventListener('load', tryDecode, { once: true });
        img.addEventListener('error', function () { setTimeout(function () { if (img.complete && img.naturalWidth) tryDecode(); }, 0); });
      });
    });
    Promise.race([Promise.all(jobs), new Promise(function (r) { setTimeout(r, WAIT); })]).then(function () {
      if (dead) return;
      startReel(0);
      requestAnimationFrame(function () { reel.classList.add('is-ready'); });
      if (o.onReady) o.onReady(ctl);
    });
    var lastH = reel.getBoundingClientRect().height, timer = null;
    function onResize() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var h = reel.getBoundingClientRect().height;
        if (Math.abs(h - lastH) < 1 || !reel.classList.contains('is-ready')) return;
        lastH = h; startReel(stopReel());
      }, 200);
    }
    function onMotion() { if (!reel.classList.contains('is-ready')) return; startReel(stopReel()); }
    window.addEventListener('resize', onResize);
    if (reduceMQ.addEventListener) reduceMQ.addEventListener('change', onMotion);
    function destroy() {
      dead = true; stopReel(); clearTimeout(timer);
      window.removeEventListener('resize', onResize);
      if (reduceMQ.removeEventListener) reduceMQ.removeEventListener('change', onMotion);
    }
    return ctl;
  };
})();
